<template>
  <div>
    <div class="d-flex align-items-center w-100 mb-2" :class="['d-flex align-items-center w-100', { 'sticky-header': showHeader }]">
      <h5 v-if="!showDetails" class="mb-0">{{title}}</h5>
      <b-button class="custom-btn-secondary mr-1 ml-auto" @click="openModalCopying()" :disabled="isBusy">
        <v-icon name="buttons/copy" :size="13"/>
        Копировать
      </b-button>
      <b-button id="table-settings" class="custom-btn-secondary mr-1" :disabled="isBusy" v-b-toggle.sidebar-fields-location-vacancies>
        <v-icon name="buttons/cog" :size="13"/>
      </b-button>
      <b-tooltip target="table-settings" triggers="hover" custom-class="custom-tooltip" noninteractive>
        Строки
      </b-tooltip>
      <b-button v-if="!showDetails" class="custom-btn-primary" @click.stop="onAdd()" :disabled="isBusy || isDisabled">
        <v-icon name="buttons/plus" :size="12"/>
        Добавить
      </b-button>
      <b-button v-if="showHeader" variant="link" class="text-dark ml-3 p-0" @click="$emit('close')">
        <v-icon name="buttons/cross" :size="15"/>
      </b-button>
    </div>

    <div v-if="items.length > 0" class="vacancies-layout">
      <div v-for="group in cardGroups" :key="group.id" class="custom-card card-body mb-4">
        <h6 class="text-secondary text-small">{{ group.title }}</h6>

        <div class="custom-card-grid-container" :style="gridStyle">

          <div v-for="field in group.fields" :key="field.key" style="display: contents;">
            <!-- Левая колонка строк заголовков -->
            <div class="custom-card-label-cell">
              <div class="d-flex align-items-center w-100">
                <span class="text-danger mr-2" v-if="field.required">*</span>
                <span class="font-weight-normal mr-auto">{{ field.label }}</span>

                <b-form-checkbox
                  v-if="field.isJoint && items.length > 1"
                  v-model="jointFields"
                  :value="field.key"
                  switch
                  class="warning-checkbox ml-2 mb-0"
                  @change="onToggleJoint(field.key)"
                />
              </div>
            </div>

            <!-- Правые колонки данных -->
            <div
              v-for="(item, index) in items"
              :key="`data-${field.key}-${index}`"
              class="custom-card-data-cell"
            >
              <!-- Объединённые поля -->
              <template v-if="isFieldJoint(field.key)">
                <div v-if="index === 0" class="w-100" :style="{ gridColumn: 'span var(--data-columns, 1)' }">
                    <div v-if="isFieldJoint(field.key)" class="px-1">
                      <div v-if="field.key === 'citizenships'">
                        <citizenships-multi-select
                          :value="items[0].citizenships"
                          :catalog-items="citizenshipsCatalog"
                          @input="updateAllItems('citizenships', $event)"
                          :is-disabled="isDisabled"
                        />
                      </div>

                      <div v-else-if="field.key === 'employment'" class="d-flex align-items-center w-100">
                        <base-multi-select
                          class="mr-1"
                          :value="items[0].employment_types"
                          :options="employmentTypesOptions"
                          :is-disabled="isDisabled"
                          @input="updateAllItems('employment_types', $event)"
                        />
                        <b-form-textarea
                          class="text-small"
                          :value="items[0].employment"
                          @input="updateAllItems('employment', $event)"
                          :disabled="isDisabled" rows="2" :placeholder="field.placeholder"
                        />
                      </div>

                      <div v-else-if="field.key === 'employment_categories'" class="w-100">
                        <employment-categories-multi-select
                          :value="items[0].employment_categories"
                          :catalog-items="employmentCategoriesCatalog"
                          @input="updateAllItems('employment_categories', $event)"
                          :is-disabled="isDisabled"
                          class="w-100"
                        />
                      </div>

                      <div v-else-if="field.key === 'certificates'" class="d-flex align-items-center w-100">
                        <driver-license-categories-multi-select
                          class="w-25 mr-1"
                          :value="items[0].driver_license_categories"
                          :catalog-items="driverLicenseCategoriesCatalog"
                          @input="updateAllItems('driver_license_categories', $event)"
                          :is-disabled="isDisabled"
                        />
                        <b-form-textarea
                          class="w-75 text-small"
                          :value="items[0].certificates"
                          @input="updateAllItems('certificates', $event)"
                          :disabled="isDisabled" rows="2" :placeholder="field.placeholder"
                        />
                      </div>

                      <div v-else-if="field.key === 'shift_hours'" class="d-flex align-items-center px-1">
                        <b-form-input
                          type="time"
                          :value="getShiftTime(items[0].shift_hours, 0)"
                          @input="updateShiftTimeJoint(0, $event)"
                          :disabled="isDisabled"
                          class="mr-1"
                        />
                        <b-form-input
                          type="time"
                          :value="getShiftTime(items[0].shift_hours, 1)"
                          @input="updateShiftTimeJoint(1, $event)"
                          :disabled="isDisabled"
                          class="mr-1"
                        />
                      </div>

                      <div v-else-if="field.key === 'schedule'" class="d-flex align-items-center w-100">
                        <b-form-textarea
                          :value="items[0].schedule"
                          @input="updateAllItems('schedule', $event)"
                          :disabled="isDisabled"
                          rows="1" max-rows="4"
                          class="mr-1 text-small"
                          placeholder="График"
                        />
                        <base-multi-select
                          class="mr-1"
                          :value="items[0].schedule_time_of_day"
                          :options="shiftOptions"
                          :is-disabled="isDisabled"
                          @input="updateAllItems('schedule_time_of_day', $event)"
                        />
                        <b-form-textarea
                          :value="items[0].night_coefficient"
                          @input="updateAllItems('night_coefficient', $event)"
                          :disabled="isDisabled"
                          rows="2"
                          max-rows="6"
                          class="text-small"
                          placeholder="Ночной коэф."
                        />
                      </div>

                      <b-form-textarea
                        v-else-if="field.type === 'input'"
                        :disabled="isDisabled"
                        rows="2"
                        max-rows="6"
                        :value="items[0][field.key]"
                        @input="updateAllItems(field.key, $event)"
                        class="text-small"
                        :placeholder="field.placeholder || 'Значение для всех вакансий'"
                      />

                      <b-form-input
                        v-else-if="field.type === 'number'"
                        :disabled="isDisabled"
                        type="number"
                        :min="0"
                        :value.number="items[0][field.key]"
                        @input="updateAllItems(field.key, $event)"
                        class="text-small"
                        :placeholder="field.placeholder || 'Введите число'"
                        @keydown="onlyNumbers"
                      />

                      <div v-else-if="field.type === 'range'" class="d-flex align-items-center w-100 px-5">
                        <b-form-input
                          :disabled="isDisabled"
                          type="number"
                          :value="items[0].age_from"
                          @input="updateAllItems('age_from', $event)"
                          class="text-small mr-5"
                          placeholder="От"
                          @keydown="onlyNumbers"
                        />
                        <b-form-input
                          :disabled="isDisabled"
                          type="number"
                          :value="items[0].age_to"
                          @input="updateAllItems('age_to', $event)"
                          class="text-small"
                          placeholder="До"
                          @keydown="onlyNumbers"
                        />
                      </div>

                      <div v-else-if="field.type === 'checkbox-input'" class="d-flex align-items-center w-100 px-3">
                        <b-form-checkbox
                          :checked="items[0][field.key]"
                          @change="updateAllItems(field.key, $event)"
                          :disabled="isDisabled"
                          class="mr-2 mb-0"
                        />
                        <b-form-textarea
                          :value="items[0][field.commentKey]"
                          @input="updateAllItems(field.commentKey, $event)"
                          :disabled="isDisabled"
                          rows="2"
                          max-rows="6"
                          class="text-small"
                          :placeholder="field.placeholder || 'Добавьте комментарий'"
                        />
                      </div>

                      <div v-else-if="field.type === 'multiselect'" class="d-flex align-items-center justify-content-center w-100">
                        <base-multi-select
                          :value="items[0][field.key]"
                          :options="getOptions(field.optionsKey)"
                          :is-disabled="isDisabled"
                          @input="updateAllItems(field.key, $event)"
                        />
                      </div>
                    </div>
                </div>
              </template>

              <!-- separated fields -->
              <template v-else>
                <div v-if="field.key === 'vacancy'" class="w-100 d-flex">

                    <vacancy-select
                      ref="vacancy_select"
                      :value="items[index].vacancy_id"
                      :is-disabled="isDisabled"
                      @onSelect="onSelectVacancy($event, index)"
                      class="w-100"
                    />
                    <b-button v-if="!showDetails" :disabled="isDisabled" class="custom-btn-danger ml-1" @click="onRemove(index)">
                      <v-icon name="buttons/trash" :size="14"/>
                    </b-button>

                </div>

                <div v-else-if="field.key === 'citizenships'" class="w-100">
                  <citizenships-multi-select
                    v-model="items[index].citizenships"
                    :catalog-items="citizenshipsCatalog"
                    :is-disabled="isDisabled"
                  />
                </div>

                <div v-else-if="field.key === 'employment_categories'" class="w-100">
                  <employment-categories-multi-select
                    v-model="items[index].employment_categories"
                    :catalog-items="employmentCategoriesCatalog"
                    :is-disabled="isDisabled"
                  />
                </div>

                <div v-else-if="field.key === 'employment'" class="d-flex align-items-center w-100">
                  <base-multi-select
                    class="mr-1"
                    v-model="items[index].employment_types"
                    :options="employmentTypesOptions"
                    :is-disabled="isDisabled"
                  />
                  <b-form-textarea
                    class="text-small"
                    v-model="items[index].employment"
                    :disabled="isDisabled"
                    rows="2"
                    :placeholder="field.placeholder"
                  />
                </div>

                <div v-else-if="field.key === 'certificates'" class="d-flex align-items-center flex-wrap w-100">
                  <driver-license-categories-multi-select
                    style="flex: 1 1 40%;"
                    class="mr-1"
                    v-model="items[index].driver_license_categories"
                    :catalog-items="driverLicenseCategoriesCatalog"
                    :is-disabled="isDisabled"
                  />
                  <b-form-textarea
                    style="flex: 1 1 50%;"
                    class="text-small"
                    v-model="items[index].certificates"
                    :disabled="isDisabled"
                    rows="2"
                    :placeholder="field.placeholder"
                  />
                </div>

                <div v-else-if="field.key === 'shift_hours'" class="d-flex align-items-center justify-content-center w-100">
                  <b-form-input
                    type="time"
                    :value="getShiftTime(items[index].shift_hours, 0)"
                    @input="updateShiftTimeSeparated(index, 0, $event)"
                    :disabled="isDisabled"
                    style="max-width: 120px;"
                    class="mr-1 text-center"
                  />
                  <b-form-input
                    type="time"
                    :value="getShiftTime(items[index].shift_hours, 1)"
                    @input="updateShiftTimeSeparated(index, 1, $event)"
                    :disabled="isDisabled"
                    class="text-center"
                    style="max-width: 120px;"
                  />
                </div>

                <div v-else-if="field.key === 'schedule'" class="d-flex align-items-center justify-content-center w-100">
                  <b-form-textarea
                    v-model="items[index].schedule"
                    :disabled="isDisabled"
                    rows="2"
                    max-rows="6"
                    class="mr-1 text-small"
                    placeholder="Укажите график"
                  />
                  <base-multi-select
                    class="mr-1"
                    v-model="items[index].schedule_time_of_day"
                    :options="shiftOptions"
                    :is-disabled="isDisabled"
                  />
                  <b-form-textarea
                    v-model="items[index].night_coefficient"
                    :disabled="isDisabled"
                    rows="2"
                    max-rows="6"
                    class="text-small"
                    placeholder="Ночной коэф."
                  />
                </div>

                <b-form-textarea
                  v-else-if="field.type === 'input'"
                  :disabled="isDisabled"
                  rows="2"
                  max-rows="6"
                  class="text-small"
                  v-model="items[index][field.key]"
                  :placeholder="field.placeholder"
                />

                <b-form-input
                  v-else-if="field.type === 'number'"
                  :disabled="isDisabled"
                  :min="0"
                  class="text-small"
                  type="number"
                  v-model.number="items[index][field.key]"
                  :placeholder="field.placeholder"
                  @keydown="onlyNumbers"
                />

                <div v-else-if="field.type === 'range'" class="d-flex justify-content-center w-100 px-4">
                  <b-form-input
                    :disabled="isDisabled"
                    type="number"
                    min="0"
                    v-model.number="items[index].age_from"
                    class="mr-4"
                    placeholder="От"
                    @keydown="onlyNumbers"
                  />
                  <b-form-input
                    :disabled="isDisabled"
                    type="number"
                    min="0"
                    v-model.number="items[index].age_to"
                    placeholder="До"
                    @keydown="onlyNumbers"
                  />
                </div>

                <div v-else-if="field.type === 'checkbox-input'" class="d-flex align-items-center w-100">
                  <b-form-checkbox
                    v-model="items[index][field.key]"
                    :disabled="isDisabled"
                    class="mr-2 mb-0"
                  />
                  <b-form-textarea
                    v-model="items[index][field.commentKey]"
                    :disabled="isDisabled"
                    rows="2"
                    max-rows="6"
                    class="text-small"
                    :placeholder="field.placeholder || 'Комментарий'"
                  />
                </div>

                <div v-else-if="field.type === 'multiselect'" class="d-flex align-items-center justify-content-center w-100">
                  <base-multi-select
                    v-model="items[index][field.key]"
                    :options="getOptions(field.optionsKey)"
                    :is-disabled="isDisabled"
                  />
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-else-if="isBusy" class="text-center text-success my-2">
      <b-spinner class="align-middle"/>
      <strong>Загрузка</strong>
    </div>

    <div v-else class="empty-state-container">
      <v-icon name="navbar/empty_table" :size="90"/>
      <h5>Нет созданных вакансий.</h5>
      <p>Создайте новую вакансию объекта прямо сейчас</p>
      <b-button v-if="!showDetails" class="custom-btn-primary" @click.stop="onAdd()" :disabled="isBusy || isDisabled">
        <v-icon name="buttons/plus" :size="12"/>
        Новая вакансия
      </b-button>
    </div>

    <div class="page-pagination mt-2" v-if="!showDetails">
      <pagination-footer
        :total-rows="items.length"
        :per-page="50"
      >
        <template #footer-pagination>
          <div class="d-none"></div>
        </template>
        <template #footer-per-page>
          <div class="d-none"></div>
        </template>
      </pagination-footer>
    </div>

    <b-modal
      id="modal-vacancy-copying"
      ref="modal_vacancy_copying"
      title="Текст вакансий объекта"
      size="xl"
      modal-class="custom-modal"
      lazy
      scrollable
      no-close-on-backdrop
      no-close-on-esc
      v-model="showModalCopying"
    >
      <b-form v-if="items.length > 0">
        <b-tabs card vertical class="custom-tabs ml-2">
          <b-tab
            v-for="(item, index) in items"
            :key="index"
            :title="vacancyModalTabTitles[index]"
          >
            <b-row class="mb-2">
              <b-col cols="auto" class="ml-auto">
                <b-button class="custom-btn-primary" @click="copyToClipboard(index)">
                  <v-icon name="buttons/copy" :size="13"/>
                  Скопировать текст
                </b-button>
              </b-col>
            </b-row>
            <b-form-textarea
              :id="'vacancy-text-' + index"
              no-resize
              readonly
              rows="45"
              class="p-3 bg-light copy-textarea"
              :value="generateVacancyText(item)"
            />
          </b-tab>
        </b-tabs>
      </b-form>
      <div v-else class="text-center text-muted py-4">
        Нет добавленных вакансий.
      </div>
      <template #modal-footer="{cancel}">
        <b-button class="custom-btn-secondary" @click="closeModalCopying()">
          Назад
        </b-button>
      </template>
    </b-modal>

    <dynamic-tables
      storage-key="locationVacancies_columns"
      sidebar-fields="sidebar-fields-location-vacancies"
      :fields-model.sync="columns"
      fieldKey="vacancy"
      :configure-required="true"
    />

  </div>
</template>

<script>
import locationVacancies from "../../network/locationVacancies";
import catalogs from "../../network/catalogs";
  import helpers from "../../utilites/helpers";
  import DynamicTables from "../../utilites/commonUi/DynamicTables.vue";
    import VacancySelect from "../Catalogs/Vacancies/VacancySelect.vue";
    import CitizenshipsMultiSelect from "../Catalogs/Citizenships/CitizenshipsMultiSelect.vue";
    import EmploymentCategoriesMultiSelect from "../Catalogs/EmploymentCategories/EmploymentCategoriesMultiSelect.vue";
    import DriverLicenseCategoriesMultiSelect from "../Catalogs/DriverLicenseCategories/DriverLicenseCategoriesMultiSelect.vue";
    import PaginationFooter from "../../utilites/commonUi/PaginationFooter.vue";
import BaseMultiSelect from "../../utilites/commonUi/BaseMultiSelect.vue";

export default {
  name: "LocationVacancies",
  components: {BaseMultiSelect, PaginationFooter, DriverLicenseCategoriesMultiSelect, EmploymentCategoriesMultiSelect, CitizenshipsMultiSelect, VacancySelect, DynamicTables },
  mixins: [
    locationVacancies, catalogs,
    helpers
  ],
  props: {
    isDisabled: { type: Boolean, default: false },
    showDetails: { type: Boolean, default: false },
    showHeader: { type: Boolean, default: false },
    localItems: { type: Array, default: () => null},
  },
  data() {
    return {
      locationId: null,
      locationName: '',
      isBusy: false,
      showModalCopying: false,
      items: [],
      deletedItems: [],
      columns: [
        {
          key: 'vacancy',
          label: 'Вакансия',
          type: 'input',
          visible: true,
          isJoint: false,
          required: true,
          isRequiredLocked: true,
        },
        {
          key: 'workers_count',
          label: 'Количество исполнителей',
          type: 'number',
          placeholder: 'Количество человек в заявке',
          visible: true,
          isJoint: false,
          required: true,
          isRequiredLocked: true,
        },
        {
          key: 'duties',
          label: 'Обязанности',
          type: 'input',
          visible: true,
          isJoint: false,
          required: false,
        },
        // Требования
        { key: 'sep_requirements', label: 'Требования', isSeparator: true },
        {
          key: 'sex',
          label: 'Пол',
          type: 'input',
          visible: true,
          isJoint: false,
          required: false,
        },
        {
          key: 'age_range',
          label: 'Возраст от и до',
          type: 'range',
          visible: true,
          isJoint: true,
          required: false,
        },
        {
          key: 'citizenships',
          label: 'Гражданство',
          visible: true,
          isJoint: true,
          required: false,
        },
        {
          key: 'criminal_record',
          commentKey: 'criminal_record_comment',
          label: 'Судимость',
          placeholder: 'Добавьте комментарий',
          type: 'checkbox-input',
          visible: true,
          isJoint: false,
          required: false,
        },
        {
          key: 'work_exp',
          label: 'Опыт работы',
          placeholder: 'Опыт, требуемый для выполнения работы',
          type: 'input',
          visible: true,
          isJoint: true,
          required: false,
        },
        {
          key: 'physical_work',
          commentKey: 'physical_work_comment',
          label: 'Физический труд',
          placeholder: 'Добавьте комментарий',
          type: 'checkbox-input',
          visible: true,
          isJoint: true,
          required: false,
        },
        {
          key: 'expectations',
          label: 'Ожидания от кандидата',
          type: 'input',
          placeholder: 'Например: порядочность, исполнительность, пунктуальность и т.д.',
          visible: true,
          isJoint: true,
          required: false,
        },
        {
          key: 'certificates',
          label: 'Удостоверения / права',
          placeholder: 'Нужны ли удостоверения или права',
          visible: true,
          isJoint: true,
          required: false,
        },
        {
          key: 'medical_book',
          commentKey: 'medical_book_comment',
          label: 'Медкнижка',
          type: 'checkbox-input',
          visible: true,
          isJoint: true,
          required: false,
        },
        // Условия
        { key: 'sep_conditions', label: 'Условия', isSeparator: true },
        {
          key: 'employment',
          label: 'Оформление',
          placeholder: 'Например: договор оказания услуг по СМЗ, выплаты на карту, без оформления',
          visible: true,
          isJoint: true,
          required: false,
        },
        {
          key: 'output_format',
          label: 'Формат выхода',
          type: 'multiselect',
          optionsKey: 'outputFormatOptions',
          visible: true,
          isJoint: true,
          required: false,
        },
        {
          key: 'employment_categories',
          label: 'Занятость',
          visible: true,
          isJoint: true,
          required: false,
        },
        {
          key: 'schedule',
          label: 'График',
          visible: true,
          isJoint: true,
          required: false,
        },
        {
          key: 'shift_hours',
          label: 'Часы работы',
          visible: true,
          isJoint: true,
          required: false,
        },
        {
          key: 'break_hours',
          label: 'График перерывов',
          type: 'input',
          visible: true,
          isJoint: true,
          required: false,
        },
        {
          key: 'work_rate',
          label: 'Выработка (норма)',
          placeholder: 'То, что мы ожидаем от исполнителя как минимум работы',
          type: 'input',
          visible: true,
          isJoint: true,
          required: false,
        },
        {
          key: 'salary',
          label: 'Ставка',
          placeholder: 'Общая для всех, кроме бригадиров',
          type: 'number',
          visible: true,
          isJoint: true,
          required: false,
        },
        {
          key: 'salary_smz',
          label: 'Ставка СМЗ',
          placeholder: 'Сколько за смену получит исполнитель (количество часов * ставка за час)',
          type: 'number',
          visible: true,
          isJoint: true,
          required: false,
        },
        {
          key: 'salary_hand',
          commentKey: 'salary_hand_comment',
          label: 'Карта / на руки',
          placeholder: 'Добавьте комментарий',
          type: 'checkbox-input',
          visible: true,
          isJoint: true,
          required: false,
        },
        {
          key: 'payment_period',
          label: 'Периодичность выплат',
          type: 'input',
          visible: true,
          isJoint: true,
          required: false,
        },
        {
          key: 'probation',
          label: 'Стажировка',
          type: 'input',
          visible: true,
          isJoint: true,
          required: false,
        },
        {
          key: 'compensation',
          label: 'Компенсации',
          type: 'input',
          visible: true,
          isJoint: true,
          required: false,
        },
        {
          key: 'meals',
          label: 'Питание',
          type: 'input',
          visible: true,
          isJoint: true,
          required: false,
        },
        {
          key: 'accommodation',
          label: 'Проживание',
          type: 'input',
          visible: true,
          isJoint: true,
          required: false,
        },
        {
          key: 'brigadier_bonus',
          label: 'Бригадирская надбавка',
          type: 'input',
          visible: true,
          isJoint: true,
          required: false,
        },
        {
          key: 'uniform',
          label: 'Униформа',
          type: 'input',
          visible: true,
          isJoint: true,
          required: false,
        },
        {
          key: 'wardrobe',
          label: 'Раздевалка',
          placeholder: 'Например, закрывается/не закрывается, описание где хранить ценные вещи',
          type: 'input',
          visible: true,
          isJoint: true,
          required: false,
        },
        {
          key: 'indoor_conditions',
          label: 'Характеристика помещений',
          placeholder: 'Температурный режим, чистота, условия проветривания и т.д.',
          type: 'input',
          visible: true,
          isJoint: true,
          required: false,
        },
        {
          key: 'transport',
          label: 'Как добраться',
          type: 'input',
          visible: true,
          isJoint: true,
          required: false,
        },
        {
          key: 'corp_transport',
          commentKey: 'corp_transport_comment',
          label: 'Корпоративный транспорт',
          placeholder: 'Добавить ссылку на точку отправления, либо указать адрес с описанием точки отправки корпоративного транспорта',
          type: 'checkbox-input',
          visible: true,
          isJoint: true,
          required: false,
        },
        {
          key: 'security_service',
          commentKey: 'security_service_comment',
          label: 'Служба безопасности',
          placeholder: 'Если есть СБ, указать требуемые документы, срок проверки',
          type: 'checkbox-input',
          visible: true,
          isJoint: true,
          required: false,
        },
        {
          key: 'access_mode',
          commentKey: 'access_mode_comment',
          label: 'Пропускной режим',
          placeholder: 'Требуемые документы, например, паспорт',
          type: 'checkbox-input',
          visible: true,
          isJoint: true,
          required: false,
        },
        {
          key: 'prohibited',
          label: 'Ограничения на объекте',
          placeholder: 'Например, использование телефона, украшений',
          type: 'input',
          visible: true,
          isJoint: true,
          required: false,
        },
      ],
      jointFields: [],
      outputFormatOptions: [
        { value: 'group', text: 'Групповой' },
        { value: 'single', text: 'По одному' }
      ],
      employmentTypesOptions: [
        { value: 1, text: 'СМЗ' },
        { value: 2, text: 'ГПХ' },
        { value: 3, text: 'ФЛ' },
        { value: 4, text: 'ИП' },
        { value: 5, text: 'В штате' },
      ],
      shiftOptions: [
        { value: 'day', text: 'День' },
        { value: 'night', text: 'Ночь' }
      ],
      citizenshipsCatalog: [],
      employmentCategoriesCatalog: [],
      driverLicenseCategoriesCatalog: []
    };
  },
  computed: {

    cardGroups() {
      const groups = [];

      let currentGroup = {
        id: 'main',
        title: 'ОСНОВНАЯ ИНФОРМАЦИЯ',
        fields: []
      };

      this.columns.forEach(col => {
        if (col.isSeparator) {
          if (currentGroup.fields.length > 0) {
            groups.push(currentGroup);
          }
          currentGroup = {
            id: col.key,
            title: col.label.toUpperCase(),
            fields: []
          };
          return;
        }

        if (col.visible) {
          currentGroup.fields.push(col);
        }
      });

      if (currentGroup.fields.length > 0) {
        groups.push(currentGroup);
      }

      return groups;
    },
    gridStyle() {
      return {
        '--data-columns': this.items.length || 1
      };
    },
    vacancyModalTabTitles() {
      return this.items.map((item, index) => item.vacancy_name || `Вакансия ${index + 1}`);
    },
    title() {
      return this.items.length > 1 ? 'Вакансии' : 'Вакансия';
    }
  },
  watch: {
    localItems: {
      handler(newValue) {
        if (newValue) {
          this.items = newValue;
        }
      }, deep: true, immediate: true
    },
    columns: {
      handler(newValue) {
        this.$emit('config-updated', newValue);
      }, deep: true, immediate: true
    }
  },
  methods: {
    configure(locationId = null, locationName = '', vacancyId = null, forceCreate = false) {
      this.isBusy = true;
      this.locationId = locationId;
      this.locationName = locationName;

      this.items = [];

      if (this.localItems && this.localItems.length > 0) {
        this.items = this.localItems;
        this.isBusy = false;
        return;
      }

      if (vacancyId) {
        this.getVacancy(vacancyId);
      } else if (this.locationId && !forceCreate) {
        this.getVacancies();
      } else {
        this.onAdd();
        this.isBusy = false;
      }
    },
    async getVacancy(vacancyId) {
      const result = await this.getLocationVacancyById(vacancyId);

      if (!result || !result.data) {
        this.isBusy = false;
        return;
      }

      this.items = [result.data];
      this.isBusy = false;
    },
    async getVacancies() {
      const result = await this.getLocationVacancyByLocationId(this.locationId);

      if (!result || !result.data) {
        this.isBusy = false;
        return;
      }

      this.items = result.data.items;
      this.isBusy = false;
    },
    updateLocation(newLocationId, newLocationName) {
      this.locationId = newLocationId;

      this.items.forEach(item => {
        item.location_id = newLocationId;
        item.location_name = newLocationName;
      });
    },
    async saveVacancies(location) {
      const requests = this.items.map(async (item, index) => {
        const generatedText = this.generateVacancyText(item);
        const processedText = generatedText
          .replace(/\n+/g, '; ')       // переносы строк
          .replace(/-\s/g, '')         // дефисы с пробелами
          .replace(/:\s*;/g, ':')      // : после заголовков
          .replace(/;\s*;/g, ';')      // дублирующиеся точки с запятой
          .replace(/\s+/g, ' ')        // множественные пробелы в один
          .trim();                     // лишние пробелы по краям

        const vacanciesData = { ...item, text: processedText };
        vacanciesData.location_id = item.location_id || location.id;
        vacanciesData.location_name = item.location_name || location.name;

        let result;

        if (vacanciesData.id > 0) {
          result = await this.putLocationVacancy(vacanciesData).catch(() => null);
        } else {
          result = await this.postLocationVacancy(vacanciesData).catch(() => null);
        }

        if (result && result.data) {
          this.items[index].id = result.data.id;
          return true;
        }
        return false;
      });

      const deleteRequests = this.deletedItems.map(async (item) => {
        const result = await this.deleteLocationVacancy(item).catch(() => null);
        return !(!result || result.error);
      });

      const results = await Promise.all([...requests, ...deleteRequests]);

      if (results.includes(false)) {
        return { error: true };
      }

      this.deletedItems = [];
      return { success: true };
    },
    onAdd() {
      const data = {
        id: null,
        location_id: this.locationId,
        location_name: this.locationName,
        vacancy_id: null,
        vacancy_name: '',
        workers_count: null,
        duties: '',
        // требования
        sex: '',
        age_from: null,
        age_to: null,
        citizenships: [],
        criminal_record: false,
        criminal_record_comment: '',
        work_exp: '',
        expectations: '',
        physical_work: false,
        physical_work_comment: '',
        medical_book: false,
        medical_book_comment: '',
        certificates: '',
        driver_license_categories: [],
        // условия
        employment: '',
        employment_types: [],
        employment_categories: [],
        schedule: '',
        schedule_time_of_day: [],
        night_coefficient: '',
        output_format: [],
        shift_hours: '',
        break_hours: '',
        work_rate: '',
        salary: null,
        salary_smz: null,
        salary_hand: false,
        salary_hand_comment: '',
        payment_period: '',
        probation: '',
        compensation: '',
        meals: '',
        accommodation: '',
        brigadier_bonus: '',
        uniform: '',
        wardrobe: '',
        indoor_conditions: '',
        transport: '',
        corp_transport: false,
        corp_transport_comment: '',
        security_service: false,
        security_service_comment: '',
        access_mode: false,
        access_mode_comment: '',
        prohibited: '',
        text: ''
      };

      this.columns.forEach(col => {
        if (this.isFieldJoint(col.key)) {
          data[col.key] = Array.isArray(this.items[0][col.key]) ? [...this.items[0][col.key]] : this.items[0][col.key];

          if (col.key === 'employment') data.employment_types = [...this.items[0].employment_types];

          if (col.key === 'certificates') data.driver_license_categories = [...this.items[0].driver_license_categories];

          if (col.key === 'schedule') {
            data.schedule_time_of_day = [...this.items[0].schedule_time_of_day];
            data.night_coefficient = this.items[0].night_coefficient;
          }
        }
      });

      this.items.push(data);
    },
    onRemove(col) {
      const index = parseInt(col, 10);
      const deleteItem = this.items[index];

      if (deleteItem.id != null) {
        this.deletedItems.push(deleteItem);
      }

      const vacancyName = deleteItem.vacancy_name || 'Новая вакансия';
      const title = "Удаление вакансии";
      const message = `Вы уверены, что хотите удалить вакансию: "${vacancyName}"?`;
      this.showModalDelete(title, message, () => {
        this.items.splice(index, 1);
      });
    },
    isFieldJoint(key) {
      return this.jointFields.includes(key);
    },
    onToggleJoint(key) {
      if (this.isFieldJoint(key)) {
        const aggregateValue = this.items.length > 0 ? this.items[0][key] : '';
        this.updateAllItems(key, aggregateValue);
      }
    },
    updateAllItems(key, event) {
      this.items.forEach(item => {
        this.$set(item, key, event);
      });
    },
    onSelectVacancy(vacancy, col) {
      const itemData = this.items[col];

      if (!itemData) return;

      if (vacancy != null) {
        this.$set(itemData, 'vacancy_id', vacancy.id);
        this.$set(itemData, 'vacancy_name', vacancy.name);
      } else {
        this.$set(itemData, 'vacancy_id', null);
        this.$set(itemData, 'vacancy_name', '');
      }
    },
    // text copying
    openModalCopying() {
      this.$refs.modal_vacancy_copying.show();
      this.showModalCopying = true;
    },
    closeModalCopying() {
      this.showModalCopying = false;
    },
    generateVacancyText(item) {
      return this.generateVacancyTextString(item);
    },
    copyToClipboard(index) {
      const text = this.generateVacancyText(this.items[index]);

      if (navigator.clipboard) {
        navigator.clipboard.writeText(text)
          .then(() => {
            this.$bvToast.toast(`Текст вакансии скопирован.`, {
              title: 'Успешно',
              variant: 'success',
              autoHideDelay: 2000,
              solid: true
            });
          })
          .catch(() => {
            this.$bvToast.toast(`Не удалось скопировать текст.`, {
              title: 'Ошибка',
              variant: 'danger',
              autoHideDelay: 2000,
              solid: true
            });
          });
      }
    },
    getOptions(optionsKey) {
      return this[optionsKey] || [];
    },
    getShiftTime(shiftHoursStr, index) {
      if (!shiftHoursStr) return '';

      const parts = shiftHoursStr.split(' - ');
      return parts[index] || '';
    },
    updateShiftTimeJoint(index, newValue) {
      const shiftTime = this.items[0].shift_hours || ' - ';
      let parts = shiftTime.split(' - ');

      if (parts.length !== 2) parts = ['', ''];

      parts[index] = newValue || '';
      let updatedString = parts.join(' - ');

      if (updatedString === ' - ') updatedString = '';

      this.updateAllItems('shift_hours', updatedString);
    },
    updateShiftTimeSeparated(itemIndex, timeIndex, newValue) {
      const shiftTime = this.items[itemIndex].shift_hours || ' - ';
      let parts = shiftTime.split(' - ');

      if (parts.length !== 2) { parts = ['', '']; }

      parts[timeIndex] = newValue || '';
      let updatedString = parts.join(' - ');

      if (updatedString === ' - ') { updatedString = ''; }

      this.$set(this.items[itemIndex], 'shift_hours', updatedString);
    },
    getGeneratedText() {
      if (!this.items) return '';

      const item = this.items[0];
      const generatedText = this.generateVacancyText(item);

      return generatedText
        .replace(/\n+/g, '; ')
        .replace(/-\s/g, '')
        .replace(/:\s*;/g, ':')
        .replace(/;\s*;/g, ';')
        .replace(/\s+/g, ' ')
        .trim();
    }
  }
};
</script>

<style>
.copy-textarea {
  height: auto !important;
}

.vacancies-layout {
  overflow-x: auto;
  overflow-y: visible;
  width: 100%;
}

.vacancies-layout .custom-card {
  width: fit-content !important;
  min-width: 100% !important;
}

.custom-card-grid-container {
  display: grid;
  grid-template-columns: 240px repeat(var(--data-columns), minmax(300px, 1fr));
  row-gap: 8px;
  column-gap: 12px;
  min-width: 100%;
}

.custom-card-label-cell {
  display: flex;
  align-items: center;
  padding: 12px;
  border-radius: 16px;
  position: relative;
  height: 100%;
}

.custom-card-data-cell {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 12px;
  background: rgba(10, 15, 23, 0.02);
  border-radius: 12px;
  position: relative;
  min-width: 0;
}

.warning-checkbox ::v-deep .custom-control-input:checked ~ .custom-control-label::before {
  border-color: #ffc107;
  background-color: #ffc107;
}

.warning-checkbox ::v-deep .custom-control-input:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 0.2rem rgba(255, 195, 10, 0.25);
}
</style>



// WEBPACK FOOTER //
// src/components/Locations/LocationVacancies.vue